<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-medium"
    title="確認"
  >
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <div class="font-weight-bold mb-3">
              <span>アプライアンス契約を変更します。よろしいですか？</span>
              <span v-if="applianceChange">
                <br />
                一度解約した場合、再契約することはできません。</span
              >
            </div>
            <app-label-group
              :label="isUtmOrIfw === 'UTM' ? 'UTM契約' : 'インターネットFW契約'"
            >
              <template #value>
                <div
                  class="ml-3 mt-2"
                  :class="{ 'text-error': applianceChange }"
                >
                  {{
                    $filter.enumTo(
                      isUtmOrIfw === "UTM"
                        ? contractChangeType1Appliance.utmEnabled
                        : contractChangeType1Appliance.ifwEnabled,
                      "contractChangeStatus"
                    )
                  }}
                </div>
              </template>
            </app-label-group>
            <app-label-group label="NAT契約" class="mt-3">
              <template #value>
                <div class="ml-3 mt-2" :class="{ 'text-error': natChange }">
                  {{
                    $filter.enumTo(
                      contractChangeType1Appliance.natEnabled,
                      "contractChangeStatus"
                    )
                  }}
                </div>
              </template>
            </app-label-group>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn variant="flat" color="primary" @click="ok">はい</v-btn>
            <v-btn variant="outlined" color="outline-primary" @click="cancel"
              >いいえ
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { ContractChangeType1Appliance } from "@/apis/ContractChangeType1Api";
import AppLabelGroup from "@/components/AppLabelGroup.vue";

export default defineComponent({
  name: "InternetType1ContractApplianceConfirm",
  components: { AppLabelGroup },
  props: {
    contractChangeType1Appliance: {
      type: Object as PropType<ContractChangeType1Appliance>,
      required: true,
    },
    /**
     * UTM契約、インターネットFW契約のどちらに該当するか判断
     * UTM: UTM契約
     * IFW: インターネットFW契約
     */
    isUtmOrIfw: {
      type: String as PropType<string>,
      required: true,
    },
    /** アプライアンスが解約の場合にtrue */
    applianceChange: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    /** NAT契約状態に変更があった場合にtrue */
    natChange: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
  },
});
</script>
